import { useHostScheduleState } from 'View/host-schedule/state';

const useResetState = () => {
  const { resetState, resetFilterState } = useHostScheduleState();

  const resetStateHandler = () => {
    resetFilterState();
    resetState();
  };

  return resetStateHandler;
};

export default useResetState;
